<header class="black-bg mh-header mh-fixed-nav nav-scroll mh-xs-mobile-nav"
    id="mh-header">
    <div class="overlay"></div>
    <div class="container">
        <div class="row">
            <nav class="navbar navbar-expand-lg mh-nav nav-btn">
                <button class="navbar-toggler" type="button"
                    data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon icon"></span>
                </button>

                <div class="collapse navbar-collapse"
                    id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto ml-auto">
                        <li class="nav-item" [class.active]="selectedPage === 'rdm-home'">
                            <a class="nav-link" href="#rdm-home" (click)="controlSelectedPage('rdm-home');">Página Inicial</a>
                        </li>
                        <li class="nav-item" [class.active]="selectedPage === 'rdm-about'">
                            <a class="nav-link" href="#rdm-about" (click)="controlSelectedPage('rdm-about');">Sobre</a>
                        </li>
                        <li class="nav-item" [class.active]="selectedPage === 'rdm-skills'">
                            <a class="nav-link" href="#rdm-skills" (click)="controlSelectedPage('rdm-skills');">Skills</a>
                        </li>
                        <li class="nav-item" [class.active]="selectedPage === 'rdm-experience'">
                            <a class="nav-link" href="#rdm-experience" (click)="controlSelectedPage('rdm-experience');">Experiências</a>
                        </li>
                        <li class="nav-item" [class.active]="selectedPage === 'rdm-contact'">
                            <a class="nav-link" href="#rdm-contact" (click)="controlSelectedPage('rdm-contact');">Contato</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</header>